module.exports = __webpack_public_path__ + "static/media/mail.aaa37fdb.svg";